import React from 'react'
import AddBook from '../components/Add Book/AddBook';

const AddaBook = () => {
    return (
        <div>
            <AddBook />
        </div>
    )
}

export default AddaBook;
